import React from "react";
import "./Internals.css";
import Jsx from "./jsx";
import reactHighlevel from "./img/reactFlowHighlevel.png";
import { Link } from "react-router-dom";

export default function Internals() {
  return (
    <>
      <div className="content">
        React allows us to write maintainable and performant code by using the
        concept of components.
        <br />
        <b>
          <em>
            <u>React is Declarative</u>
          </em>
        </b>{" "}
        - Components allows us to foucus on describing the UI we want, rather
        than focusing on the details of how the UI actually gets inserted in the
        pages. React do the tracking of the all of the individual{" "}
        <em>
          <u title="An element is a plain object describing the component">
            elements
          </u>
        </em>{" "}
        and let us focus on the building the application.
      </div>
      <div
        className="contentimp"
        title="bcz., browser has to Re-Paint, do frame animations/network requests etc., So easier to generate objects than DOM updates"
      >
        Writing on to the DOM is most expensive thing than creating thousands of
        JavaScript objects
      </div>
      <div className="content">
        <b>High level flow of React:</b> <br />
        <div className="imgAlign">
          <img className="imgSize moreWidth" src={reactHighlevel}></img>
        </div>
        <div>
          {" "}
          <Link to="/jsx"> JSX </Link> &rarr; JS Objects &rarr; Render (virtual
          DOM &harr; Real DOM)
        </div>{" "}
        <br />
        Virtual DOM is an <em>`in memory`</em> representation of the real DOM.{" "}
        During the initial rendering process, React generates virtual DOM.{" "}
        <br />
        When state changes, React updates the virtual DOM tree, after the
        virtual DOM update, react tries to compare the current version of the
        virtual DOM with the previous version of the virtual DOM. This process
        is Diffing. Later, it performs{" "}
        <em title="React follows observable patterns and performs batch updates, so it is very fast.">
          batch
        </em>{" "}
        updating on the real DOM which makes react more efficient.
      </div>
    </>
  );
}
